<div class="instructions">
  <motif-icon
    [iconFunction]="IconoirInfoCircle"
    size="28"
    style="color: #000000"
  ></motif-icon>

  <div class="text-container">
    <h2 class="instructions-header">Instructions</h2>
    <ol class="instructions-ol">
      <li>
        Select the Chart of Accounts (COA) template in the drop-down menu (FS /
        standard i.e. UKI).
      </li>
      <li>
        For existing entity, upload the latest mapping file downloaded from
        Beehive.
      </li>
      <li>
        Ensure the latest mapping file:
        <ul class="instructions-ul">
          <li>
            Has column headers exactly as “Account Code”, “Account Description”
            and “Beehive Mapping Path”.
          </li>
          <li>
            The Beehive Mapping Path match that of the FS / standard Beehive
            COA.
          </li>
        </ul>
      </li>
    </ol>
    <h3 class="instructions-subtitle">Additional guidance</h3>
    <ol class="instructions-ol">
      <li>
        The Agent works best when Account Descriptions are meaningful and free
        of unnecessary special characters.
      </li>
      <li>
        If a latest mapping file is uploaded, the AI generated mapping will be
        based on the Beehive mapping paths in the file.
      </li>
    </ol>
  </div>
</div>
